module.exports = __webpack_public_path__ + "img/check-solid.032fc128.svg";